import { render, staticRenderFns } from "./admin-database-setup-layout.component.vue?vue&type=template&id=007053f6"
import script from "./admin-database-setup-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-database-setup-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007053f6')) {
      api.createRecord('007053f6', component.options)
    } else {
      api.reload('007053f6', component.options)
    }
    module.hot.accept("./admin-database-setup-layout.component.vue?vue&type=template&id=007053f6", function () {
      api.rerender('007053f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/admin-database-setup-layout/admin-database-setup-layout.component.vue"
export default component.exports